// /parent — the parent Overview dashboard (PR-PARENT-OVERVIEW, closes #43).
// Replaced the stubbed ParentDashboard (QA audit Area 4) with real signals.
import { createFileRoute } from "@tanstack/react-router";
import { ParentOverview } from "@/screens/ParentOverview";
export const Route = createFileRoute("/parent/")({ component: ParentOverview });
